import React from 'react'
import { MidiaContainer } from "../../../containers";
export default function MidiaPage(props) {
    return (
        <div style={ { flexGrow: 1, display: 'flex' } } className='midia-page-container'>
            <MidiaContainer/>
        </div>
    )
}
